export interface Vec2 {
  x: number;
  y: number;
}

export interface Circle {
  center: Vec2;
  radius: number;
}

export function distance(a: Vec2, b: Vec2): number {
  'worklet';
  return Math.hypot(b.x - a.x, b.y - a.y);
}

/** Edge-to-edge space: positive apart, zero at contact, negative overlapped. */
export function gap(a: Circle, b: Circle): number {
  'worklet';
  return distance(a.center, b.center) - (a.radius + b.radius);
}

export function overlaps(a: Circle, b: Circle): boolean {
  'worklet';
  return gap(a, b) < 0;
}

/**
 * Where the kiss lands: the midpoint of the two nearest edges, on the
 * center line. This is where the bloom wicks outward from.
 *
 * Midpoint of nearest edges while edges face each other; clamps to the
 * far center under containment (one circle wholly inside the other).
 */
export function kissPoint(a: Circle, b: Circle): Vec2 {
  'worklet';
  const d = distance(a.center, b.center);
  if (d === 0) return { ...a.center };
  const t = Math.min(1, Math.max(0, (a.radius + (d - b.radius)) / 2 / d));
  return {
    x: a.center.x + (b.center.x - a.center.x) * t,
    y: a.center.y + (b.center.y - a.center.y) * t,
  };
}
